const iconfont = 'fa';

export default iconfont;
